export function SET_QUOTATIONS (state, data) {
    state.quotations = data.quotations
}

export function SET_CONSOLIDITY (state, data) {
    state.consolidity = data.consolidity
}